import { render, staticRenderFns } from "./RefundList2_Success.vue?vue&type=template&id=6bb4e99f&scoped=true&"
import script from "./RefundList2_Success.vue?vue&type=script&lang=js&"
export * from "./RefundList2_Success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb4e99f",
  null
  
)

export default component.exports